<div id="hms-logo">
  <img
    [ngSrc]="layoutService.getLogoByTheme()"
    [width]="105" [height]="37" [alt]="('HSIMAGE' | translate)" disableOptimizedSrcset priority 
    class="img-fluid" appNgSrcImageError />
</div>

<!--<div id="company-logo">
    <app-customer-icon></app-customer-icon>
</div>-->